import { defineComponent as _defineComponent } from 'vue'
import V3Icon from "@/components/v3-icons/V3Icon.vue";
import { computed } from "vue";
import V3SlideDownTransition from "@/components/v3-transitions/V3SlideDownTransition.vue";
import { Item } from "@/types/components/V3SideBar.type";
import V3SideBarItemNew from "@/components/v3-side-bar/V3SideBarItemNew.vue";
import { useRoute } from "vue-router/composables";
import { isItemActive } from "@/components/v3-side-bar/v3-side-bar-util";
import { useSearchBalloon } from "@/v3-composables/use-search-balloon";


export default /*#__PURE__*/_defineComponent({
  __name: 'V3SideBarItemExpandableNew',
  props: {
    icon: null,
    text: null,
    subitems: null,
    isExpanded: { type: Boolean },
    showMinimized: { type: Boolean }
  },
  emits: ["click-subitem", "toggle-subitems"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: "click-subitem", subitem: Item): void;
  (event: "toggle-subitems", storageKey: string | undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  icon: string;
  text: string;
  subitems: Item[];
  isExpanded: boolean;
  showMinimized?: boolean;
};

const route = useRoute();
const { showSearchBalloon, hideSearchBalloon } = useSearchBalloon();





const isDisabled = computed(() => props.subitems.length === 0);

const isActive = computed(() => {
  return props.subitems.some(item => isItemActive(route, item));
});

return { __sfc: true,route, showSearchBalloon, hideSearchBalloon, props, emits, isDisabled, isActive, V3Icon, V3SlideDownTransition, V3SideBarItemNew, isItemActive }
}

})